export const SHIFT_ISSUES_FETCH_BEGIN = 'syftacp/SHIFT_ISSUES_FETCH_BEGIN' as const
export const SHIFT_ISSUES_FETCH_FAILED = 'syftacp/SHIFT_ISSUES_FETCH_FAILED' as const
export const SHIFT_ISSUES_FETCH_SUCCEEDED = 'syftacp/SHIFT_ISSUES_FETCH_SUCCEEDED' as const
